(function () {
  'use strict';

  var DIALOG_ID = 'kjs-consent-preferences-dialog';
  var API_FEATURE = { name: 'consent-tracking-api', version: '0.1' };

  function privacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function setFooterStatus(message) {
    var status = document.querySelector('[data-kjs-privacy-status]');
    if (status) status.textContent = message || '';
  }

  function consentValue(value, allowedFallback) {
    if (value === 'yes' || value === true) return true;
    if (value === 'no' || value === false) return false;
    return !!allowedFallback;
  }

  function currentChoices() {
    var api = privacyApi();
    var current = api && typeof api.currentVisitorConsent === 'function'
      ? api.currentVisitorConsent()
      : {};

    return {
      analytics: consentValue(
        current.analytics,
        api && typeof api.analyticsProcessingAllowed === 'function' && api.analyticsProcessingAllowed()
      ),
      marketing: consentValue(
        current.marketing,
        api && typeof api.marketingAllowed === 'function' && api.marketingAllowed()
      ),
      preferences: consentValue(
        current.preferences,
        api && typeof api.preferencesProcessingAllowed === 'function' && api.preferencesProcessingAllowed()
      )
    };
  }

  function buildDialog() {
    var dialog = document.getElementById(DIALOG_ID);
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = DIALOG_ID;
    dialog.className = 'kjs-consent-dialog';
    dialog.setAttribute('aria-labelledby', DIALOG_ID + '-title');
    dialog.innerHTML = [
      '<div class="kjs-consent-dialog__panel">',
      '  <button class="kjs-consent-dialog__close" type="button" data-kjs-consent-close aria-label="Close cookie preferences">&times;</button>',
      '  <h2 id="' + DIALOG_ID + '-title">Cookie preferences</h2>',
      '  <p class="kjs-consent-dialog__intro">Choose which optional cookies we may use. Essential cookies are always active because the store needs them to work.</p>',
      '  <div class="kjs-consent-dialog__essential">',
      '    <span><strong>Essential</strong><small>Security, checkout and basic site functions</small></span>',
      '    <span class="kjs-consent-dialog__always">Always active</span>',
      '  </div>',
      '  <label class="kjs-consent-choice">',
      '    <span><strong>Preferences</strong><small>Remember settings such as language and location</small></span>',
      '    <input type="checkbox" data-kjs-consent-choice="preferences">',
      '  </label>',
      '  <label class="kjs-consent-choice">',
      '    <span><strong>Analytics</strong><small>Help us understand and improve how the site is used</small></span>',
      '    <input type="checkbox" data-kjs-consent-choice="analytics">',
      '  </label>',
      '  <label class="kjs-consent-choice">',
      '    <span><strong>Marketing</strong><small>Support advertising and measure marketing activity</small></span>',
      '    <input type="checkbox" data-kjs-consent-choice="marketing">',
      '  </label>',
      '  <p class="kjs-consent-dialog__sharing">To limit data sharing separately, use our <a href="/pages/data-sharing-opt-out">data-sharing opt-out</a>.</p>',
      '  <p class="kjs-consent-dialog__status" data-kjs-consent-dialog-status role="status" aria-live="polite"></p>',
      '  <div class="kjs-consent-dialog__actions">',
      '    <button type="button" class="kjs-consent-dialog__button kjs-consent-dialog__button--secondary" data-kjs-consent-all="false">Decline optional</button>',
      '    <button type="button" class="kjs-consent-dialog__button kjs-consent-dialog__button--secondary" data-kjs-consent-save>Save choices</button>',
      '    <button type="button" class="kjs-consent-dialog__button kjs-consent-dialog__button--primary" data-kjs-consent-all="true">Accept all</button>',
      '  </div>',
      '</div>'
    ].join('');

    document.body.appendChild(dialog);
    bindDialog(dialog);
    return dialog;
  }

  function syncDialog(dialog) {
    var choices = currentChoices();
    Object.keys(choices).forEach(function (name) {
      var input = dialog.querySelector('[data-kjs-consent-choice="' + name + '"]');
      if (input) input.checked = choices[name];
    });
  }

  function setDialogBusy(dialog, isBusy) {
    Array.prototype.forEach.call(dialog.querySelectorAll('button, input'), function (control) {
      control.disabled = isBusy;
    });
    dialog.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function saveChoices(dialog, choices) {
    var api = privacyApi();
    var status = dialog.querySelector('[data-kjs-consent-dialog-status]');

    if (!api || typeof api.setTrackingConsent !== 'function') {
      if (status) status.textContent = 'Cookie preferences are temporarily unavailable. Please refresh and try again.';
      return;
    }

    setDialogBusy(dialog, true);
    if (status) status.textContent = 'Saving your choices…';

    try {
      api.setTrackingConsent(choices, function () {
        setDialogBusy(dialog, false);
        if (status) status.textContent = '';
        setFooterStatus('Cookie preferences saved.');
        closeDialog(dialog);
      });
    } catch (error) {
      setDialogBusy(dialog, false);
      if (status) status.textContent = 'Your choices could not be saved. Please try again.';
    }
  }

  function bindDialog(dialog) {
    dialog.addEventListener('click', function (event) {
      var close = event.target.closest('[data-kjs-consent-close]');
      var save = event.target.closest('[data-kjs-consent-save]');
      var all = event.target.closest('[data-kjs-consent-all]');
      var choices;

      if (close) {
        closeDialog(dialog);
        return;
      }

      if (!save && !all) return;

      if (all) {
        choices = all.getAttribute('data-kjs-consent-all') === 'true';
        saveChoices(dialog, {
          analytics: choices,
          marketing: choices,
          preferences: choices
        });
        return;
      }

      saveChoices(dialog, {
        analytics: !!dialog.querySelector('[data-kjs-consent-choice="analytics"]:checked'),
        marketing: !!dialog.querySelector('[data-kjs-consent-choice="marketing"]:checked'),
        preferences: !!dialog.querySelector('[data-kjs-consent-choice="preferences"]:checked')
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog(dialog);
    });
  }

  function openDialog(button) {
    var dialog = buildDialog();
    var api = privacyApi();

    if (!api) {
      setFooterStatus('Loading cookie preferences…');
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([API_FEATURE], function (error) {
          if (error || !privacyApi()) {
            setFooterStatus('Cookie preferences are temporarily unavailable. Please refresh and try again.');
            return;
          }
          openDialog(button);
        });
        return;
      }
    }

    setFooterStatus('');
    syncDialog(dialog);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    window.setTimeout(function () {
      var first = dialog.querySelector('[data-kjs-consent-choice]');
      if (first) first.focus();
    }, 0);
  }

  function interceptPreferenceButton(event) {
    var button = event.target.closest && event.target.closest('[data-kjs-cookie-preferences]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openDialog(button);
  }

  function bindPreferenceButtons(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-kjs-cookie-preferences]'), function (button) {
      if (button.getAttribute('data-kjs-phase8-consent-bound') === 'true') return;
      button.setAttribute('data-kjs-phase8-consent-bound', 'true');
      button.addEventListener('click', interceptPreferenceButton, true);
    });
  }

  document.addEventListener('click', interceptPreferenceButton, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindPreferenceButtons(document); });
  } else {
    bindPreferenceButtons(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    bindPreferenceButtons(event.target);
  });
}());

